import React from "react";

const Footer = () => {
  return (
    <footer className="pad-top120 foot-bg" style={{ paddingBottom: "0px" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <div className="foot-se">
              <h4> Institute</h4>
              <p>
                {" "}
                <a
                  href="https://heartfulness.org/education/"
                  rel="noreferrer"
                  target="_blank"
                >
                  {" "}
                  Education{" "}
                </a>
              </p>
              <p>
                {" "}
                <a
                  href="https://www.heartfulnessinstitute.org/medical/"
                  rel="noreferrer"
                  target="_blank"
                >
                  {" "}
                  Continual Medical Education{" "}
                </a>
              </p>
              <p>
                {" "}
                <a
                  href="http://heartfulness.org/education/yoga-trainers/"
                  rel="noreferrer"
                  target="_blank"
                >
                  {" "}
                  Yoga Teachers Training Certification
                </a>
              </p>
              <p>
                {" "}
                <a
                  href="https://www.heartfulnessinstitute.org/research"
                  rel="noreferrer"
                  target="_blank"
                >
                  {" "}
                  Heartfulness Research{" "}
                </a>
              </p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="foot-se">
              <h4> Quick Links</h4>
              <ul className="foot-list">
                <li>
                  <a
                    href="https://www.daaji.org/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Daaji
                  </a>
                </li>
                <li>
                  <a
                    href="http://sahajmarg.org/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    {" "}
                    Sahaj Marg
                  </a>
                </li>
                <li>
                  <a
                    href="https://kanha.sahajmarg.org/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Kanha Shanti Vanam{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://kanha.sahajmarg.org/green-kanha/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Green kanha{" "}
                  </a>
                </li>
              </ul>
              <ul className="foot-list">
                <li>
                  <a
                    href="https://www.srcm.org/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Shri Ram Chandra Mission{" "}
                  </a>
                </li>
              </ul>
              <ul className="foot-list">
                <li>
                  <a
                    href="https://heartfulness.org/in/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    {" "}
                    Spirituality Foundation
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 ">
            <div className="foot-se">
              <h4> Related Links</h4>
            </div>
            <ul className="foot-list">
              <li>
                <a href="https://hfnlife.com/" rel="noreferrer" target="_blank">
                  {" "}
                  Publication{" "}
                </a>
              </li>
              <li>
                <a
                  href="https://www.shriramchandramission.org//digitalstore/"
                  rel="noreferrer"
                  target="_blank"
                >
                  Digital Store{" "}
                </a>
              </li>
            </ul>
            <ul className="foot-list">
              <li>
                <a href="https://hfnlife.com/" rel="noreferrer" target="_blank">
                  {" "}
                  HFNLife online store
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-3">
            <div className="foot-se">
              <img
                src="images/footermagazine.png"
                className="maxine-custom-height img-fluaid"
                alt="HFN maxinsine"
                width="90%"
                placeholder="blurred"
              />
              <p className="heart-magazine">Heartfulness magazine</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container pad-left0-right0">
        <div className="row mg-bottom30 mar-30">
          <div className="col-lg-8 col-md-8">
            <p className=" practies-text">
              {" "}
              Heartfulness practices with a certified trainer are always free,
              whether in person or online.
            </p>
          </div>
          <div className="col-lg-4">
            <div className="social-part text-center">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/practiceheartfulness/"
              >
                <img
                  src="images/Facebook Icon.svg"
                  className=""
                  alt="Facebook icon"
                  placeholder="blurred"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://twitter.com/heartful_ness"
              >
                <img
                  src="images/Twitter.svg"
                  className=""
                  alt="Twitter icon"
                  placeholder="blurred"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://instagram.com/heartfulness"
              >
                <img
                  src="images/Instagram Icon.svg"
                  className=""
                  alt="Instagram icon"
                  placeholder="blurred"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.youtube.com/channel/UCoG2o8WtvYh8sCS40pUFtCg"
              >
                <img
                  src="images/Youtube Icon.svg"
                  className=""
                  alt="Youtube icon"
                  placeholder="blurred"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://linkedin.com/company/heartfulness"
              >
                <img
                  src="images/Linkedin.svg"
                  className=""
                  alt="Linked icon"
                  placeholder="blurred"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="foot2">
        <div className="container">
          <div className=" border-top-line ">
            <div className="row">
              <div className="col-lg-8 ">
                <p className="clr-white">
                  © Copyright 2021 Sahaj Marg Spirituality Foundation, All
                  Rights Reserved.{" "}
                </p>
              </div>
              <div className="col-lg-4 col-md-4">
                <div>
                  <ul className="term-of-site">
                    <li>
                      {" "}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://heartfulness.org/en/terms/"
                      >
                        {" "}
                        Terms of Use{" "}
                      </a>{" "}
                    </li>
                    <li> | </li>
                    <li>
                      {" "}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://heartfulness.org/en/privacy-policy/"
                      >
                        {" "}
                        Privacy Cookie Policy{" "}
                      </a>{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
